var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _circle2, _circle3, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _g, _path55, _path56, _path57, _g2, _g3, _g4, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _circle4, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _g5, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _g6, _g7, _path115, _path116, _path117, _path118, _path119;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 752.86 771.28"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rocket_svg__linear-gradient",
    y1: 573.08,
    x2: 752.86,
    y2: 573.08,
    gradientTransform: "matrix(1 0 0 -1 0 842.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3f6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#c6ebfd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rocket_svg__linear-gradient-2",
    x1: 185.84,
    y1: 349.19,
    x2: 265.83,
    y2: 349.19,
    xlinkHref: "#rocket_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rocket_svg__linear-gradient-3",
    x1: 435.13,
    y1: 343.34,
    x2: 515.13,
    y2: 343.34,
    xlinkHref: "#rocket_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rocket_svg__linear-gradient-4",
    x1: 234.03,
    y1: 586.16,
    x2: 468.09,
    y2: 586.16,
    xlinkHref: "#rocket_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("style", null, ".rocket_svg__cls-1{fill:#ecf2fa}.rocket_svg__cls-2{fill:#8bbacc}.rocket_svg__cls-3,.rocket_svg__cls-4{fill:#274b5b}.rocket_svg__cls-10,.rocket_svg__cls-11,.rocket_svg__cls-4{opacity:.2}.rocket_svg__cls-10,.rocket_svg__cls-11,.rocket_svg__cls-21,.rocket_svg__cls-22,.rocket_svg__cls-4,.rocket_svg__cls-5,.rocket_svg__cls-9{isolation:isolate}.rocket_svg__cls-12,.rocket_svg__cls-21,.rocket_svg__cls-22,.rocket_svg__cls-5{fill:#fff}.rocket_svg__cls-5{opacity:.3}.rocket_svg__cls-15{opacity:.4}.rocket_svg__cls-9{fill:#1b5a6e}.rocket_svg__cls-21,.rocket_svg__cls-9{opacity:.8}.rocket_svg__cls-10{fill:#a7594e}.rocket_svg__cls-11{fill:#f08778}.rocket_svg__cls-16{fill:#426270}.rocket_svg__cls-17{opacity:.9}.rocket_svg__cls-22{opacity:.15}"))), /*#__PURE__*/React.createElement("g", {
    id: "rocket_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rocket_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rocket_svg__Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rocket_svg__Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-1",
    d: "M288.05,514.37H415a26.33,26.33,0,0,1-26.33,26.33H314.39a26.33,26.33,0,0,1-26.33-26.33h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-2",
    d: "M415.58,516.59a26.33,26.33,0,0,1-13.89,21.59,25.43,25.43,0,0,1-4.89,1.76l.09-.24a10.86,10.86,0,0,0-9.95-14.45L291.1,522.5a25.84,25.84,0,0,1-1.17-5.93,15,15,0,0,0,2.12.15h33.49v2.34h7v-2.34h17.92c-.19.41-.4.82-.59,1.22l26.56-.05v-1.17h37.17A14.43,14.43,0,0,0,415.58,516.59Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M305.02 517.88H307.35999999999996V538.95H305.02z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M306.78 517.88H309.11999999999995V536.02H306.78zM321.41 517.88H323.75V536.02H321.41zM350.67 517.88H353.01V536.02H350.67zM365.3 517.88H367.64V536.02H365.3zM379.93 517.88H382.27V536.02H379.93z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-5",
    d: "M375.25 517.88H377.59V536.02H375.25zM361.2 517.88H363.53999999999996V536.02H361.2zM346.57 517.88H348.90999999999997V536.02H346.57zM331.94 517.88H334.28V536.02H331.94zM317.31 517.88H319.65V536.02H317.31zM302.68 517.88H305.02V536.02H302.68z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M336.04 517.88H338.38V536.02H336.04z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M319.56 517.88H321.9V538.95H319.56zM334.09 517.88H336.42999999999995V538.95H334.09zM348.62 517.88H350.96V538.95H348.62zM377.69 517.88H380.03V538.95H377.69zM392.22 517.88H394.56V538.95H392.22zM363.15 517.88H365.48999999999995V538.95H363.15z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M742.62,319.5H599.31q-.28-4.1-.67-8.19h56.18a10.24,10.24,0,0,0,0-20.48H595.59c-2.9-14.09-7.5-27.27-14.57-38.42-13.85-21.83-35.48-32.68-56.76-35s-42.63,3.14-63.59,9c-27.91,7.8-60.7,14.82-81.73-11-12.44-15.27-17.4-40.31-13-62.12a158.55,158.55,0,0,1,4.36-15.83h73.82a10.24,10.24,0,0,0,0-20.48H375.76a57.76,57.76,0,0,0,.76-9.54,52.6,52.6,0,0,0-19.58-40c-10.75-8.41-23.33-11.39-35.7-13.56-27.63-4.86-56.13-6.3-83,3.13-25.47-27.48-61.33-36.77-92.59-23.78A60.65,60.65,0,0,0,122.4,49.72h61.05a9.95,9.95,0,0,1,0,19.9H111.77c-4.61,15-4.56,32.39-4.33,48.87,0,1.85.05,3.7.08,5.55h28.83a10.24,10.24,0,0,1,0,20.48H107.82l.16,11.12h67a10.24,10.24,0,0,1,0,20.48H108.26c0,2.34.06,4.72.1,7.09.24,16.63.42,33.72-3.91,49.3C91.1,280.5,43.81,292.06,18.27,330H125.82a10.24,10.24,0,0,1,0,20.48H7.84q-1.4,3.72-2.54,7.61h76a10.24,10.24,0,1,1,0,20.48H1A137.91,137.91,0,0,0,8.78,444c17.37,45.27,57.73,68.21,95.7,67.5s74.12-21.07,108.15-43.64c25.72-17.08,52.63-36.15,81.27-33.46,29.2,2.75,54.18,27.55,80.6,44.44,43,27.5,93.12,34.53,139.44,19.55,20.48-6.62,40.77-17.88,55.77-37.76,14.55-19.31,22.82-44.85,26.92-72h39.21a9.95,9.95,0,0,0,0-19.9H598.89c.74-9.16,1.08-18.38,1.09-27.5V340H742.62a10.24,10.24,0,1,0,0-20.48Z",
    style: {
      isolation: "isolate"
    },
    fill: "url(#rocket_svg__linear-gradient)",
    opacity: 0.4
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M265.83,489.21s-47.83,59.54-54.29,143a3.67,3.67,0,0,1-7.14.87c-16.39-49.87-51.18-194,57.35-282",
    fill: "url(#rocket_svg__linear-gradient-2)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M210.84,637.2a3.62,3.62,0,0,0,1.42,1.93,3.66,3.66,0,0,1-5.52-1.93c-16.39-49.87-51.18-194,57.35-282l.1,3.32C160.53,446.74,194.65,588,210.84,637.2Z",
    fill: "#f6df9e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-9",
    d: "M200.14,617.91c-.28-23.14,5.62-47.4,13.37-69.12,4-11.12,8.41-21.56,12.76-30.84a197.9,197.9,0,0,0,18.51-93.12c-.86-18.57-1.56-39.39-1.56-57.94,8.57-10.62,5.66-11.58,17.37-21.07l4.1,138.11s-47.84,59.54-54.3,143A3.55,3.55,0,0,1,209,629.6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M200,539.54a2,2,0,1,1,2-2A2.05,2.05,0,0,1,200,539.54Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,200,536.61Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M200,541.29a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,200,541.29Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,200,536Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M208.17,464a2,2,0,1,1,2-2A2.05,2.05,0,0,1,208.17,464Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,208.17,461.12Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M208.17,465.8A3.8,3.8,0,1,1,212,462,3.81,3.81,0,0,1,208.17,465.8Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,208.17,460.53Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M495.51,464a2,2,0,1,1,2-2A2.05,2.05,0,0,1,495.51,464Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,495.51,461.12Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M495.51,465.8a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,495.51,465.8Zm0-5.27A1.46,1.46,0,1,0,497,462,1.46,1.46,0,0,0,495.51,460.53Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M493.75,464a2,2,0,1,1,2-2A2.05,2.05,0,0,1,493.75,464Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,493.75,461.12Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M493.75,465.8a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,493.75,465.8Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,493.75,460.53Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M217.83 404.35H220.17000000000002V596.3H217.83z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M220.17 399.67H222.51V596.3H220.17z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-5",
    d: "M215.49 404.35H217.83V596.3H215.49z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M231.29 379.19H233.63V552.41H231.29z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M233.63 379.19H235.97V552.41H233.63z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-5",
    d: "M228.95 379.19H231.29V552.41H228.95z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-10",
    d: "M472.35,697A47.44,47.44,0,0,1,425,649.53v-46.2h12.87v46.2a34.56,34.56,0,1,0,56.94-26.34l8.34-9.81a47.44,47.44,0,0,1-26.88,83.43Q474.3,697,472.35,697Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-11",
    d: "M467,676.92a28.66,28.66,0,0,1-4.17-.31l1.87-12.74a15.34,15.34,0,1,0-6.93-27.49l-7.69-10.33A28.22,28.22,0,1,1,467,676.92Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "rocket_svg__cls-11",
    cx: 471.22,
    cy: 586.94,
    r: 9.36
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-12",
    d: "M489.64,639a3.62,3.62,0,0,1-1.42,1.93,3.66,3.66,0,0,0,5.52-1.93c16.39-49.87,51.18-194-57.35-282l-.1,3.32C539.95,448.49,505.82,589.71,489.64,639Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M435.13,495.06s47.83,59.54,54.29,143a3.67,3.67,0,0,0,7.14.87c16.39-49.87,51.18-194-57.35-282",
    fill: "url(#rocket_svg__linear-gradient-3)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-9",
    d: "M500.83,623.77c.28-23.14-5.62-47.4-13.37-69.12-4-11.12-8.41-21.56-12.76-30.84a197.91,197.91,0,0,1-18.51-93.12c.86-18.57,1.56-39.39,1.56-57.94-8.57-10.62-5.66-11.58-17.37-21.07l-4.1,138.11s47.84,59.54,54.3,143a3.55,3.55,0,0,0,1.39,2.63"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M500.78,540.12a2,2,0,1,1,2-2A2.05,2.05,0,0,1,500.78,540.12Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,500.78,537.2Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M500.78,541.88a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,500.78,541.88Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,500.78,536.61Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M480.59 403.77H482.92999999999995V601.5699999999999H480.59z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M478.25 403.18H480.59V585.1800000000001H478.25z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-5",
    d: "M482.93 409.62H485.27V601.5699999999999H482.93z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M467.13 384.46H469.46999999999997V557.68H467.13z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M464.79 384.46H467.13V551.8299999999999H464.79z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-5",
    d: "M469.47 384.46H471.81V557.68H469.47z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M493.12,641.78a8.36,8.36,0,0,1-1-.06,8,8,0,0,1-7.07-7.38c-6.28-81.2-52.87-140-53.34-140.62l6.84-5.5c.5.62,12.4,15.54,25.22,41,11.5,22.81,25.83,58.6,29.72,100.88,7.93-25,19.52-71.28,16.85-121.7-3.38-63.93-28.25-115.11-73.9-152.11l5.53-6.82a201.42,201.42,0,0,1,58.3,75.8c10.9,24.76,17.24,52.57,18.83,82.67,2.87,54.24-10.28,103.68-18.38,128.32A8,8,0,0,1,493.12,641.78Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-11",
    d: "M93.18,771.28H51.63a6.44,6.44,0,0,1,0-12.87H93.18a6.44,6.44,0,0,1,0,12.87Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-10",
    d: "M276.39,713.9a53.82,53.82,0,0,1-34.91-94.84l8.34,9.81a41,41,0,1,0,67.49,31.21V558.85h12.87V660.09a53.79,53.79,0,0,1-53.8,53.81Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-11",
    d: "M374.93 738.53a30.14 30.14 0 01-30.09-30.14V608.62h12.87v99.78a17.26 17.26 0 1028.44-13.15l8.34-9.81a30.14 30.14 0 01-17.08 53Q376.17 738.53 374.93 738.53zM343.65 559.43H356.52V590.4499999999999H343.65zM279.72 688a28.57 28.57 0 01-4.17-.31L277.43 675a15.34 15.34 0 10-6.93-27.49l-7.69-10.33A28.22 28.22 0 11279.72 688z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-11",
    d: "M388.12 670.62a20.48 20.48 0 1120.48-20.48A20.51 20.51 0 01388.12 670.62zm0-28.09a7.61 7.61 0 107.61 7.61A7.62 7.62 0 00388.12 642.53zM286.88 618.54a20.48 20.48 0 1120.48-20.48A20.51 20.51 0 01286.88 618.54zm0-28.09a7.61 7.61 0 107.61 7.61A7.62 7.62 0 00286.88 590.45zM564.86 618.54a20.48 20.48 0 1120.48-20.48A20.51 20.51 0 01564.86 618.54zm0-28.09a7.61 7.61 0 107.61 7.61A7.62 7.62 0 00564.86 590.45z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "rocket_svg__cls-11",
    cx: 163.99,
    cy: 640.78,
    r: 4.68
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "rocket_svg__cls-11",
    cx: 424.99,
    cy: 720.95,
    r: 4.68
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-10",
    d: "M582.41,743.19H569.54A34.57,34.57,0,0,0,535,708.66h-8.78V695.79H535A47.46,47.46,0,0,1,582.41,743.19Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-11",
    d: "M113.66 745.67H100.79A93.29 93.29 0 01194 652.48h18.59v12.87H194A80.4 80.4 0 00113.66 745.67zM675.33 743.19H662.45A99.6 99.6 0 00563 643.7H540.28V630.83H563A112.49 112.49 0 01675.33 743.19z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-10",
    d: "M176.86,743.19H164a47.46,47.46,0,0,1,47.4-47.4h8.78v12.87h-8.78A34.57,34.57,0,0,0,176.86,743.19Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-11",
    d: "M604.65 771.28H114.83a6.44 6.44 0 110-12.87H604.65a6.44 6.44 0 010 12.87zM28.81 771.28a6.07 6.07 0 01-1.26-.13 6.75 6.75 0 01-1.21-.36 7.2 7.2 0 01-1.11-.59 6.82 6.82 0 01-1-.8 6.37 6.37 0 01-1.39-2.09 6.82 6.82 0 01-.36-1.21 6.22 6.22 0 010-2.52 6.82 6.82 0 01.36-1.21 7.24 7.24 0 01.59-1.11 6.44 6.44 0 011.78-1.78 7.2 7.2 0 011.11-.59 6.75 6.75 0 011.21-.36 6.28 6.28 0 012.52 0 6.76 6.76 0 011.21.36 7.21 7.21 0 011.11.59 6.44 6.44 0 011.78 1.78 7.21 7.21 0 01.59 1.11 7.38 7.38 0 01.37 1.21 6.5 6.5 0 010 2.52 7.38 7.38 0 01-.37 1.21 7.21 7.21 0 01-.59 1.11 6.38 6.38 0 01-.8 1 6.79 6.79 0 01-1 .8 7.21 7.21 0 01-1.11.59 6.76 6.76 0 01-1.21.36A6.07 6.07 0 0128.81 771.28zM670.19 771.28H628.64a6.44 6.44 0 010-12.87h41.54a6.44 6.44 0 010 12.87zM693 771.28a6.06 6.06 0 01-1.26-.13 6.75 6.75 0 01-1.21-.36 7.19 7.19 0 01-1.11-.59 6.78 6.78 0 01-1-.8 6.35 6.35 0 01-.8-1 7.21 7.21 0 01-.59-1.11 7.41 7.41 0 01-.37-1.21 6.5 6.5 0 010-2.52 7.41 7.41 0 01.37-1.21 7.21 7.21 0 01.59-1.11 6.44 6.44 0 011.78-1.78 7.19 7.19 0 011.11-.59 6.75 6.75 0 011.21-.36 6.28 6.28 0 012.52 0 6.75 6.75 0 011.21.36 7.19 7.19 0 011.11.59 6.44 6.44 0 011.78 1.78 7.26 7.26 0 01.59 1.11 6.77 6.77 0 01.36 1.21 6.22 6.22 0 010 2.52 6.77 6.77 0 01-.36 1.21 7.26 7.26 0 01-.59 1.11 6.42 6.42 0 01-.8 1 6.81 6.81 0 01-1 .8 7.19 7.19 0 01-1.11.59 6.75 6.75 0 01-1.21.36A6.06 6.06 0 01693 771.28z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M207.26,641.19a8,8,0,0,1-7.61-5.55c-8.1-24.64-21.25-74.08-18.38-128.32,1.59-30.1,7.93-57.91,18.83-82.67a201.42,201.42,0,0,1,58.3-75.8l5.53,6.82c-45.65,37-70.51,88.18-73.9,152.11-2.67,50.42,8.92,96.68,16.85,121.7,3.89-42.28,18.22-78.07,29.72-100.88,12.83-25.44,24.72-40.36,25.22-41l6.84,5.5h0c-.18.23-12,15-24.34,39.66-11.42,22.7-25.72,58.65-29,101a8,8,0,0,1-7.07,7.38A8.48,8.48,0,0,1,207.26,641.19Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M360.82,5.74a13,13,0,0,0-19.5,0C313.22,37.55,234,139.82,234,282.78c0,139.93,30.34,202.76,42.18,221.94,2.53,4.1,8,6.73,14,6.73H411.87c6,0,11.53-2.62,14-6.73,11.83-19.18,42.18-82,42.18-221.94C468.11,139.82,388.93,37.54,360.82,5.74Z",
    fill: "url(#rocket_svg__linear-gradient-4)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M349.5 124.04H351.84V510.28000000000003H349.5z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M347.16 124.04H349.5V510.28000000000003H347.16z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-5",
    d: "M351.84 124.04H354.17999999999995V510.28000000000003H351.84z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-1",
    d: "M428.5,120.53H271.14a515.82,515.82,0,0,1,33.7-66.9q1.68-2.81,3.34-5.49C319.7,30.88,329.85,17.65,337,8.88a13.9,13.9,0,0,1,21.57,0,549.87,549.87,0,0,1,41.31,58.81l.4.67C409.52,83.64,419.15,101.1,428.5,120.53Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-2",
    d: "M427.33,117.85l-8.6-.24C404.52,96.82,365.2,54.4,311,48.55c1-1.87,5-6.7,6-8.49,7.78-12.79,14.86-20.37,20.65-28.57a17,17,0,0,1,27.45-.36,459.34,459.34,0,0,1,33.23,51.27c.12.22,1.42.44,1.54.67C408.31,78.38,423.82,86.83,427.33,117.85Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-12",
    d: "M294.86,105.57a2.93,2.93,0,0,1-2.57-4.32c2.85-5.24,6-10.5,9.09-15.6,3-4.94,6.06-10,8.8-15.07a2.93,2.93,0,1,1,5.14,2.8c-2.8,5.14-5.92,10.3-8.93,15.29s-6.18,10.24-9,15.37A2.93,2.93,0,0,1,294.86,105.57Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "rocket_svg__cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-16",
    d: "M380.28,226.42c3.76-6.1,6.44-11.27,6.85-11.08s-1.76,5.68-5.58,11.86-7.76,10.59-8.06,10.33S376.54,232.53,380.28,226.42Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "rocket_svg__cls-16",
    cx: 385.62,
    cy: 229.95,
    rx: 8.66,
    ry: 0.75,
    transform: "rotate(-59.55 385.614 229.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-16",
    d: "M381.76 230.47c5.5 2.22 10.09 3.75 10 4.16s-4.93-.51-10.53-2.77-9.73-5-9.53-5.3S376.26 228.26 381.76 230.47zM387 229c5 2.34 9.19 3.81 9.08 4.23s-4.61-.49-9.7-2.87-8.68-5.27-8.45-5.57S382 226.67 387 229z"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-12",
    d: "M313.36,514.37H292c-6,0-11.53-2.63-14-6.75-11.83-19.22-42.17-82.21-42.17-222.48,0-137.36,72.75-237.25,103.54-273.38C311.68,44.54,251.79,131.27,251.79,268l35.11-49.26C286.22,220.64,215.31,426.89,313.36,514.37Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-12",
    d: "M299,511.73h-5.85c-6,0-11.53-2.63-14-6.75C267.31,485.76,237,422.78,237,282.51,237,145.15,309.7,45.25,340.49,9.15c-15.71,18.62-41.91,54.74-61.55,107.6h0C258.79,162,242.81,218.11,242.81,282.49c0,140.27,30.34,203.26,42.17,222.48C287.51,509.11,293,511.73,299,511.73Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-9",
    d: "M385.22,511.45h21.34c6,0,11.53-2.62,14-6.72,11.83-19.17,42.17-82,42.17-221.83C462.78,146,390,46.33,359.24,10.3c27.66,32.67,94,119.15,94,255.48L422.8,216.66C423.49,218.56,483.27,424.22,385.22,511.45Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "rocket_svg__cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-12",
    d: "M276.5,166.78a117.46,117.46,0,0,1,3.59-11.56,86.57,86.57,0,0,1,3.94-9.07c2.57-5,4.81-7.82,5.74-7.43s.47,3.89-.78,9.25c-.63,2.67-1.43,5.85-2.34,9.32l-2.93,11.32L280.9,180c-.86,3.51-1.67,6.65-2.38,9.3-1.45,5.31-2.67,8.61-3.72,8.5s-1.64-3.62-1.51-9.26a86.61,86.61,0,0,1,.85-9.85A117.45,117.45,0,0,1,276.5,166.78Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "rocket_svg__cls-17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "rocket_svg__cls-12",
    cx: 270.25,
    cy: 211.61,
    rx: 8.78,
    ry: 3.73,
    transform: "rotate(-79.77 270.25 211.608)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-16",
    d: "M333,32.85c4.85-3.51,9.36-6.57,12.67-8.68s5.44-3.32,5.56-3.12-1.8,1.67-5,4l-12.39,9-12.38,9c-3.18,2.29-5.2,3.66-5.33,3.51s1.66-1.82,4.68-4.34S328.16,36.39,333,32.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-16",
    d: "M334.81,38.55c10.66-4.1,19.26-7.53,19.43-7.14.08.19-2,1.29-5.37,2.87s-8.19,3.62-13.52,5.66-10.26,3.74-13.85,4.82-5.85,1.64-5.92,1.46C315.42,45.82,324.14,42.64,334.81,38.55Z"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M340.43,191a2,2,0,1,1,2-2A2.05,2.05,0,0,1,340.43,191Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,340.43,188.12Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M340.43,192.8a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,340.43,192.8Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,340.43,187.54Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M340.43,151a2,2,0,1,1,2-2A2.05,2.05,0,0,1,340.43,151Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,340.43,148Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M340.43,152.72a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,340.43,152.72Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,340.43,147.45Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M360.91,163.84a2,2,0,1,1,2-2A2.05,2.05,0,0,1,360.91,163.84Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,360.91,160.91Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M360.91,165.59a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,360.91,165.59Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,360.91,160.32Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M360.91,309.55a2,2,0,1,1,2-2A2.05,2.05,0,0,1,360.91,309.55Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,360.91,306.63Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M360.91,311.31a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,360.91,311.31Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,360.91,306Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M361.5,339.4a2,2,0,1,1,2-2A2.05,2.05,0,0,1,361.5,339.4Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,361.5,336.47Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M361.5,341.15a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,361.5,341.15Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,361.5,335.89Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M338.67,301.36a2,2,0,1,1,2-2A2.05,2.05,0,0,1,338.67,301.36Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,338.67,298.43Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M338.67,303.11a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,338.67,303.11Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,338.67,297.85Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M338.67,331.2a2,2,0,1,1,2-2A2.05,2.05,0,0,1,338.67,331.2Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,338.67,328.28Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M338.67,333a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,338.67,333Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,338.67,327.69Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M340.43,231.13a2,2,0,1,1,2-2A2.05,2.05,0,0,1,340.43,231.13Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,340.43,228.21Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M340.43,232.89a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,340.43,232.89Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,340.43,227.62Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M387.25,108.83a2,2,0,1,1,2-2A2.05,2.05,0,0,1,387.25,108.83Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,387.25,105.9Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M387.25,110.58a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,387.25,110.58Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,387.25,105.31Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M313.51,108.83a2,2,0,1,1,2-2A2.05,2.05,0,0,1,313.51,108.83Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,313.51,105.9Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M313.51,110.58a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,313.51,110.58Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,313.51,105.31Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M350.38,108.83a2,2,0,1,1,2-2A2.05,2.05,0,0,1,350.38,108.83Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,350.38,105.9Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M350.38,110.58a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,350.38,110.58Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,350.38,105.31Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M340.43,375.68a2,2,0,1,1,2-2A2.05,2.05,0,0,1,340.43,375.68Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,340.43,372.75Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M340.43,377.44a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,340.43,377.44Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,340.43,372.17Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M340.43,418.59a2,2,0,1,1,2-2A2.05,2.05,0,0,1,340.43,418.59Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,340.43,415.67Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M340.43,420.35a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,340.43,420.35Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,340.43,415.08Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M340.43,461.51a2,2,0,1,1,2-2A2.05,2.05,0,0,1,340.43,461.51Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,340.43,458.59Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M340.43,463.27a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,340.43,463.27Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,340.43,458Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M340.43,504.43a2,2,0,1,1,2-2A2.05,2.05,0,0,1,340.43,504.43Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,340.43,501.5Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M340.43,506.18a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,340.43,506.18Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,340.43,500.91Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 353.89,
    cy: 240.79,
    r: 49.45,
    style: {
      isolation: "isolate"
    },
    fill: "#5c7869",
    opacity: 0.6
  }), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 354.47,
    cy: 222.65,
    r: 49.45,
    fill: "#94e0f7"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M353.89,269.17a43,43,0,1,1,43-43A43.06,43.06,0,0,1,353.89,269.17Zm0-83.1A40.09,40.09,0,1,0,394,226.16,40.13,40.13,0,0,0,353.89,186.07Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-12",
    d: "M371 178.56L342.8 273.33A49.2 49.2 0 01323.29 263L349 176.57A49.62 49.62 0 01371 178.56zM386.73 187.12l-26.1 87.65a48.34 48.34 0 01-5 .25 49.31 49.31 0 01-6-.36l27.83-93.46A49.46 49.46 0 01386.73 187.12z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-21",
    d: "M319.06,236.59a1.17,1.17,0,0,1-1.15-1,47.4,47.4,0,0,1,5.77-31.07c3.07-5.26,6.67-8.41,10.72-9.37a1.17,1.17,0,0,1,.54,2.28c-3.4.8-6.51,3.58-9.24,8.26a45.05,45.05,0,0,0-5.48,29.53,1.17,1.17,0,0,1-1,1.34Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M387.83,229.38a2,2,0,1,1,2-2A2.05,2.05,0,0,1,387.83,229.38Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,387.83,226.45Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M387.83,231.13a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,387.83,231.13Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,387.83,225.87Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M353.89,281.75a55.59,55.59,0,1,1,55.59-55.59A55.66,55.66,0,0,1,353.89,281.75Zm0-98.9a43.31,43.31,0,1,0,43.31,43.31A43.35,43.35,0,0,0,353.89,182.85Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-1",
    d: "M322.51,509.11v-85.4A114.47,114.47,0,0,1,353,345.8h0a114.49,114.49,0,0,1,29.91,77.31V509"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-12",
    d: "M357.11,357.22a111.47,111.47,0,0,0-26.92,72.65v83.92h-7V429.87a111.45,111.45,0,0,1,30.47-76.57h0Q355.43,355.23,357.11,357.22Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-2",
    d: "M377,428.22v84.4l-24.22.05c22.54-45.3,15.39-106.33,10.82-137.44A111.43,111.43,0,0,1,377,428.22Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "rocket_svg__cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-16",
    d: "M298.94,357.5c3.76-6.1,6.44-11.27,6.85-11.08s-1.76,5.68-5.58,11.86-7.76,10.59-8.06,10.33S295.2,363.61,298.94,357.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "rocket_svg__cls-16",
    cx: 304.27,
    cy: 361.03,
    rx: 8.66,
    ry: 0.75,
    transform: "rotate(-59.55 304.274 361.028)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-16",
    d: "M300.42 361.55c5.5 2.22 10.09 3.75 10 4.16s-4.93-.51-10.53-2.77-9.73-5-9.53-5.3S294.91 359.35 300.42 361.55zM305.62 360.06c5 2.34 9.19 3.81 9.08 4.23s-4.61-.49-9.7-2.87-8.68-5.27-8.45-5.57S300.64 357.76 305.62 360.06z"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M341,403.18a2,2,0,1,1,2-2A2.05,2.05,0,0,1,341,403.18Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,341,400.26Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M341,404.94a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,341,404.94Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,341,399.67Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M341,488.62a2,2,0,1,1,2-2A2.05,2.05,0,0,1,341,488.62Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,341,485.7Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M341,490.38a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,341,490.38Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,341,485.11Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M341,445.9a2,2,0,1,1,2-2A2.05,2.05,0,0,1,341,445.9Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,341,443Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M341,447.66a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,341,447.66Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,341,442.39Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M359.74,403.18a2,2,0,1,1,2-2A2.05,2.05,0,0,1,359.74,403.18Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,359.74,400.26Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M359.74,404.94a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,359.74,404.94Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,359.74,399.67Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M359.74,488.62a2,2,0,1,1,2-2A2.05,2.05,0,0,1,359.74,488.62Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,359.74,485.7Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M359.74,490.38a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,359.74,490.38Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,359.74,485.11Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M359.74,445.9a2,2,0,1,1,2-2A2.05,2.05,0,0,1,359.74,445.9Zm0-2.93a.88.88,0,1,0,.88.88A.88.88,0,0,0,359.74,443Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M359.74,447.66a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,359.74,447.66Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,359.74,442.39Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M349.5 351.69H351.84V510.28H349.5z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M347.74 357.54H350.08V508.52H347.74z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-21",
    d: "M352.43 357.54H354.77V507.94000000000005H352.43z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M387.54,545.68H313.22A30.76,30.76,0,0,1,282.49,515v-4.39H418.26V515A30.76,30.76,0,0,1,387.54,545.68Zm-95.83-26.33a22,22,0,0,0,21.5,17.56h74.32A22,22,0,0,0,409,519.35Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-22",
    d: "M412.81,154.56h0a15.84,15.84,0,0,1,19.12,11.68l3.77,15.6A15.84,15.84,0,0,1,424,201h0a15.84,15.84,0,0,1-19.12-11.68l-3.77-15.6A15.84,15.84,0,0,1,412.81,154.56Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-22",
    d: "M398.74,147.68h0a15.84,15.84,0,0,1,22,4.23h0a15.84,15.84,0,0,1-4.23,22h0a15.84,15.84,0,0,1-22-4.23h0A15.84,15.84,0,0,1,398.74,147.68Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "rocket_svg__cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-16",
    d: "M411.88,268c3.76-6.1,6.44-11.27,6.85-11.08s-1.76,5.68-5.58,11.86-7.76,10.59-8.06,10.33S408.14,274.08,411.88,268Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "rocket_svg__cls-16",
    cx: 417.22,
    cy: 271.5,
    rx: 8.66,
    ry: 0.75,
    transform: "rotate(-59.55 417.221 271.496)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-16",
    d: "M413.36 272c5.5 2.22 10.09 3.75 10 4.16s-4.93-.51-10.53-2.77-9.73-5-9.53-5.3S407.86 269.81 413.36 272zM418.57 270.52c5 2.34 9.19 3.81 9.08 4.23s-4.61-.49-9.7-2.87-8.68-5.27-8.45-5.57S413.59 268.22 418.57 270.52z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "rocket_svg__cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-16",
    d: "M364.48,87.72c3.76-6.1,6.44-11.27,6.85-11.08s-1.76,5.68-5.58,11.86S358,99.09,357.69,98.84,360.74,93.83,364.48,87.72Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "rocket_svg__cls-16",
    cx: 369.82,
    cy: 91.25,
    rx: 8.66,
    ry: 0.75,
    transform: "rotate(-59.55 369.816 91.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-16",
    d: "M366 91.77c5.5 2.22 10.09 3.75 10 4.16s-4.93-.51-10.53-2.77-9.73-5-9.53-5.3S360.46 89.57 366 91.77zM371.16 90.28c5 2.34 9.19 3.81 9.08 4.23s-4.61-.49-9.7-2.87-8.68-5.27-8.45-5.57S366.18 88 371.16 90.28z"
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-2",
    d: "M273.13 115.56H419.43V118.49000000000001H273.13z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M270.98 117.5H431.43V126.28H270.98z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M410.69,515.84H289.08c-7.6,0-14.42-3.38-17.78-8.81-12.88-20.89-42.83-84.56-42.83-224.4,0-137.05,72.2-237.39,103.24-274.17a23.79,23.79,0,0,1,36.37,0h0c31,36.78,103.25,137.13,103.22,274.17,0,139.81-30,203.5-42.83,224.39C425.16,512.45,418.34,515.84,410.69,515.84ZM349.87,8.78a14.9,14.9,0,0,0-9.66,3.54,15.05,15.05,0,0,0-1.79,1.79C308,50.16,237.25,148.47,237.25,282.63c0,60,5.56,112.21,16.51,155.28,9,35.49,19.54,55.65,25,64.51,1.72,2.78,5.86,4.64,10.31,4.64H410.69c4.47,0,8.61-1.86,10.3-4.63,5.47-8.88,16-29,25-64.53,11-43.07,16.52-95.31,16.52-155.28,0-134.15-70.73-232.47-101.15-268.51h0a14.92,14.92,0,0,0-10.21-5.28Q350.51,8.78,349.87,8.78Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-3",
    d: "M324.56 510.39h-8.78V426.46a115.39 115.39 0 0131.67-79.58l3.21-3.4 3.19 3.42a115.47 115.47 0 0131.09 79v84.4h-8.78v-84.4a106.69 106.69 0 00-25.55-69.42 106.61 106.61 0 00-26.05 70zM495.51 462.88a2 2 0 112-2A2.05 2.05 0 01495.51 462.88zm0-2.93a.88.88 0 10.88.88A.88.88 0 00495.51 459.95z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "rocket_svg__cls-4",
    d: "M495.51,464.63a3.8,3.8,0,1,1,3.8-3.8A3.81,3.81,0,0,1,495.51,464.63Zm0-5.27a1.46,1.46,0,1,0,1.46,1.46A1.46,1.46,0,0,0,495.51,459.36Z"
  })))))));
}

export default SvgRocket;